import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SxContextService } from './sxContext.service';

/**
 * Servicio para el manejo de routings dentro de
 * la aplicacion
 */
@Injectable()
export class SxRouterService {
  
  constructor(private router: Router,
              private sxContext: SxContextService) {
  }

  navigateToConfigSimpleQuery(codatributo: string, aRoute: ActivatedRoute) {
    this.sxContext.getContext(aRoute).subscribe(context => {
      const url = this.getRouteToConfigSimpleQuery(codatributo, context.organizationCode, context.subscriptionCode, context.channelCode, context.productCode);
      this.router.navigateByUrl(url);
    })
  }

  navigateToConfigSimpleQueryInNewTab(codatributo: string, aRoute: ActivatedRoute) {
    this.sxContext.getContext(aRoute).subscribe(context => {
      const url = this.getRouteToConfigSimpleQuery(codatributo, context.organizationCode, context.subscriptionCode, context.channelCode, context.productCode);
      window.open(url);
    })
  }

  private getRouteToConfigSimpleQuery(codatributo: string, organizationCode: string, subscriptionCode: string, channelCode: string, productCode: string) {
    let url = `/soc/organizations/${organizationCode}/subscriptions/${subscriptionCode}/opciones/consultaSimple`;

    if (!channelCode && !productCode) {
      url += `/sistemas`;
    }

    if (channelCode && !productCode) {
      url += `/negocios/${channelCode}`;
    }

    if (productCode) {
      url += `/productos/${channelCode}/${productCode}`;
    }

    url += `/${codatributo}`;

    return url;
  }
}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/sxRouter.service.ts